export const CEREMONY_PLACE_GROUPS = [
  {
    key: "obradni_sin",
    label: "Obřadní síň",
    items: [
      {
        id: "sin_ck",
        label: "Obřadní síň Český Krumlov",
        placeType: "obradni_sin",
        driveMinutes: 10,
        ceremonyMinutes: 20,
      },
      {
        id: "sin_horni_plana",
        label: "Obřadní síň Horní Planá",
        placeType: "obradni_sin",
        driveMinutes: 30,
        ceremonyMinutes: 20,
      },
      {
        id: "sin_vyssi_brod",
        label: "Obřadní síň Vyšší Brod",
        placeType: "obradni_sin",
        driveMinutes: 30,
        ceremonyMinutes: 20,
      },
    ],
  },
  {
    key: "kostel",
    label: "Kostel",
    items: [
      { id: "kostel_ck", label: "Kostel Český Krumlov", placeType: "kostel", driveMinutes: 10 },
      { id: "kostel_kajov", label: "Kostel Kájov", placeType: "kostel", driveMinutes: 15 },
      { id: "kostel_vyssi_brod", label: "Kostel Vyšší Brod", placeType: "kostel", driveMinutes: 30 },
      { id: "kostel_frymburk", label: "Kostel Frymburk", placeType: "kostel", driveMinutes: 30 },
      { id: "kostel_horni_plana", label: "Kostel Horní Planá", placeType: "kostel", driveMinutes: 30 },
      { id: "kostel_horice", label: "Kostel Hořice na Šumavě", placeType: "kostel", driveMinutes: 20 },
      { id: "kostel_chvalsiny", label: "Kostel Chvalšiny", placeType: "kostel", driveMinutes: 20 },
      { id: "kostel_kremze", label: "Kostel Křemže", placeType: "kostel", driveMinutes: 25 },
      { id: "kostel_rozmberk", label: "Kostel Rožmberk nad Vltavou", placeType: "kostel", driveMinutes: 30 },
      { id: "kostel_pridoli", label: "Kostel Přídolí", placeType: "kostel", driveMinutes: 15 },
      { id: "kostel_predni_vyton", label: "Kostel Přední Výtoň", placeType: "kostel", driveMinutes: 35 },
      { id: "kostel_zadni_vyton", label: "Kostel Zadní Výtoň", placeType: "kostel", driveMinutes: 35 },
      { id: "kostel_dolni_dvoriste", label: "Kostel Dolní Dvořiště", placeType: "kostel", driveMinutes: 40 },
      { id: "kostel_loucovice", label: "Kostel Loučovice", placeType: "kostel", driveMinutes: 40 },
      { id: "kostel_vetrni", label: "Kostel Větřní", placeType: "kostel", driveMinutes: 15 },
      { id: "kostel_zlata_koruna", label: "Kostel Zlatá Koruna", placeType: "kostel", driveMinutes: 15 },
      { id: "kostel_velesin", label: "Kostel Velešín", placeType: "kostel", driveMinutes: 20 },
      { id: "kostel_brloh", label: "Kostel Brloh", placeType: "kostel", driveMinutes: 35 },
      { id: "kostel_benesov", label: "Kostel Benešov nad Černou", placeType: "kostel", driveMinutes: 40 },
    ],
  },
];

export const CEREMONY_VARIANTS = [
  { id: "pred_kremaci", label: "Rozloučení před kremací" },
  { id: "do_hrobu", label: "Rozloučení do hrobu" },
  { id: "s_urnou", label: "Rozloučení s urnou" },
];

export const CHURCH_SERVICE_TYPES = [
  { id: "kratke", label: "Krátké rozloučení", ceremonyMinutes: 25 },
  { id: "bezne", label: "Běžný obřad", ceremonyMinutes: 45 },
];

export function getAllCeremonyPlaces() {
  return CEREMONY_PLACE_GROUPS.flatMap((g) => g.items || []);
}

export function getCeremonyPlaceById(id) {
  const v = String(id || "").trim();
  return getAllCeremonyPlaces().find((x) => x.id === v) || null;
}

export function getCeremonyPlaceLabel(idOrLabel) {
  const found = getCeremonyPlaceById(idOrLabel);
  return found?.label || String(idOrLabel || "").trim() || "-";
}

export function getPlaceGroupByKey(key) {
  const v = String(key || "").trim();
  return CEREMONY_PLACE_GROUPS.find((x) => x.key === v) || null;
}

export function computeCeremonyTiming({
  placeId = "",
  ceremonyVariant = "",
  churchServiceType = "",
} = {}) {
  const place = getCeremonyPlaceById(placeId);
  if (!place) {
    return {
      driveMinutes: 15,
      ceremonyMinutes: 45,
      bufferBeforeMin: 45,
      durationMin: 45,
      bufferAfterMin: 15,
      totalBlockedMin: 105,
    };
  }

  const driveMinutes = Number(place.driveMinutes || 0) || 0;
  const placeType = String(place.placeType || "").trim();
  const variant = String(ceremonyVariant || "").trim();
  const serviceType = String(churchServiceType || "").trim();

  let ceremonyMinutes = 20;

  if (placeType === "obradni_sin") {
    ceremonyMinutes = 20;
  } else if (placeType === "kostel") {
    ceremonyMinutes = serviceType === "kratke" ? 25 : 45;
    if (variant === "do_hrobu") {
      ceremonyMinutes += 30 + 10;
    }
  }

  const bufferBeforeMin = 30 + driveMinutes;
  const bufferAfterMin = driveMinutes;
  const durationMin = ceremonyMinutes;
  const totalBlockedMin = bufferBeforeMin + durationMin + bufferAfterMin;

  return {
    driveMinutes,
    ceremonyMinutes,
    bufferBeforeMin,
    durationMin,
    bufferAfterMin,
    totalBlockedMin,
  };
}
